(() => {
  const visibleClass = 'is-visible';

  class CartSuccessToast extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.duration = Number(this.dataset.duration) || 5000;
      this.message = this.dataset.message || 'Added to cart';
      this.messageElement = this.querySelector('[data-cart-success-toast-message]');
      this.titleElement = this.querySelector('[data-cart-success-toast-title]');
      this.quantityElement = this.querySelector('[data-cart-success-toast-quantity]');
      this.quantityWrapper = this.querySelector('[data-cart-success-toast-quantity-wrapper]');
      this.imageElement = this.querySelector('[data-cart-success-toast-image]');
      this.imageWrapper = this.querySelector('[data-cart-success-toast-image-wrapper]');
      this.remainingTime = this.duration;

      this.onCartAdded = this.onCartAdded.bind(this);
      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.pauseTimer = this.pauseTimer.bind(this);
      this.resumeTimer = this.resumeTimer.bind(this);

      document.addEventListener('theme:cart:added', this.onCartAdded);
      document.addEventListener('keydown', this.onKeydown);
      this.addEventListener('click', this.onClick);
      this.addEventListener('mouseenter', this.pauseTimer);
      this.addEventListener('mouseleave', this.resumeTimer);
      this.addEventListener('focusin', this.pauseTimer);
      this.addEventListener('focusout', this.resumeTimer);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:cart:added', this.onCartAdded);
      document.removeEventListener('keydown', this.onKeydown);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('mouseenter', this.pauseTimer);
      this.removeEventListener('mouseleave', this.resumeTimer);
      this.removeEventListener('focusin', this.pauseTimer);
      this.removeEventListener('focusout', this.resumeTimer);
      window.clearTimeout(this.dismissTimer);
    }

    onCartAdded(event) {
      if (event.detail?.success === false) return;

      const item = event.detail?.item || event.detail?.items?.[0] || null;
      this.show(item);
    }

    show(item) {
      const title = item?.product_title || item?.title || '';
      const quantity = item?.quantity || 1;
      const image = item?.featured_image?.url || item?.image || '';

      if (this.messageElement) this.messageElement.textContent = '';

      if (this.titleElement) {
        this.titleElement.textContent = title;
        this.titleElement.hidden = !title;
      }

      if (this.quantityElement && this.quantityWrapper) {
        this.quantityElement.textContent = quantity;
        this.quantityWrapper.hidden = false;
      }

      if (this.imageElement && this.imageWrapper) {
        if (image) {
          this.imageElement.src = image;
          this.imageWrapper.hidden = false;
        } else {
          this.imageElement.removeAttribute('src');
          this.imageWrapper.hidden = true;
        }
      }

      window.clearTimeout(this.dismissTimer);
      this.remainingTime = this.duration;
      this.classList.add(visibleClass);
      this.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(() => {
        if (this.messageElement) this.messageElement.textContent = this.message;
      });
      this.startTimer();
    }

    hide() {
      window.clearTimeout(this.dismissTimer);
      this.classList.remove(visibleClass);
      this.setAttribute('aria-hidden', 'true');
      if (this.messageElement) this.messageElement.textContent = '';
    }

    startTimer() {
      this.timerStartedAt = Date.now();
      this.dismissTimer = window.setTimeout(() => this.hide(), this.remainingTime);
    }

    pauseTimer() {
      if (!this.classList.contains(visibleClass) || !this.dismissTimer) return;

      window.clearTimeout(this.dismissTimer);
      this.dismissTimer = null;
      this.remainingTime = Math.max(0, this.remainingTime - (Date.now() - this.timerStartedAt));
    }

    resumeTimer() {
      if (!this.classList.contains(visibleClass) || this.dismissTimer) return;

      this.startTimer();
    }

    onClick(event) {
      if (event.target.closest('a')) return;
      this.hide();
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.classList.contains(visibleClass)) this.hide();
    }
  }

  if (!customElements.get('cart-success-toast')) {
    customElements.define('cart-success-toast', CartSuccessToast);
  }
})();
